import { render, staticRenderFns } from "./movementModal.vue?vue&type=template&id=89c2329e&"
import script from "./movementModal.vue?vue&type=script&lang=js&"
export * from "./movementModal.vue?vue&type=script&lang=js&"
import style0 from "./movementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports